'use client';

import * as React from 'react';
import * as SelectPrimitive from '@radix-ui/react-select';
import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Paragraph, Select, SelectContent, SelectItem } from '@app/shared/ui/atoms/Common';
import { cn } from '@app/shared/utils/common';
import { LANGUAGES } from '@app/shared/constants/common';

const SelectTrigger = React.forwardRef<
  React.ComponentRef<typeof SelectPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof SelectPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <SelectPrimitive.Trigger
    ref={ref}
    className={cn('p-0.5 focus:outline-none', className)}
    {...props}
  >
    {children}
  </SelectPrimitive.Trigger>
));
SelectTrigger.displayName = SelectPrimitive.Trigger.displayName;

interface LanguageSelectProps extends SelectPrimitive.SelectProps {
  hasText?: boolean;
}

export function LanguageSelect({ hasText, ...props }: LanguageSelectProps) {
  const { i18n } = useTranslation();

  const languageCode = i18n.resolvedLanguage?.toUpperCase();

  return (
    <Select {...props}>
      <SelectTrigger className="flex items-center gap-1">
        <Globe className="h-7 w-7 text-accent" />
        {hasText && languageCode && <Paragraph variant="accent">{languageCode}</Paragraph>}
      </SelectTrigger>

      <SelectContent align="center" sideOffset={4}>
        {LANGUAGES.map((item) => (
          <SelectItem key={item.title} value={item.lang}>
            {item.title}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
